import { useAddress } from '@/store/selector';
import { useEffect } from 'react';
import { toastApp } from '../toast-message/sonner';
import { api } from './api';
import {
    useTradingCampaignDailyStreak,
    useTradingCampaignVolume,
} from './hooks/useTradingCampaigns';

const CheckJoinCampaign = () => {
    const { data, isLoading, mutate } = useTradingCampaignVolume();
    const {
        data: dailyStreakData,
        isLoading: isLoadingDailyStreak,
        mutate: mutateDailyStreak,
    } = useTradingCampaignDailyStreak();

    const address = useAddress();

    useEffect(() => {
        if (isLoading || data?.user_tasks.length || !data?.campaign.id) {
            return;
        }

        (async () => {
            try {
                await api.joinCampaign(data.campaign.id, address);

                mutate();
            } catch {
                toastApp.error('Join Failed');
            }
        })();
    }, [
        address,
        data?.campaign.id,
        data?.user_tasks.length,
        isLoading,
        mutate,
    ]);

    useEffect(() => {
        if (
            isLoadingDailyStreak ||
            dailyStreakData?.user_tasks.length ||
            !dailyStreakData?.campaign.id
        ) {
            return;
        }

        (async () => {
            try {
                await api.joinCampaign(dailyStreakData.campaign.id, address);
                mutateDailyStreak();
            } catch {
                toastApp.error('Join Failed');
            }
        })();
    }, [
        address,
        dailyStreakData?.campaign.id,
        dailyStreakData?.user_tasks.length,
        isLoadingDailyStreak,
        mutateDailyStreak,
    ]);
    return null;
};

export default CheckJoinCampaign;
